import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const RecentTournamentCard = ({ tournament }) => {
  const navigate = useNavigate();

  const getStatusColor = (status) => {
    switch (status) {
      case 'active':
        return 'bg-success/10 text-success border-success/20';
      case 'upcoming':
        return 'bg-warning/10 text-warning border-warning/20';
      case 'completed':
        return 'bg-muted text-muted-foreground border-border';
      default:
        return 'bg-muted text-muted-foreground border-border';
    }
  };

  const formatDate = (date) => {
    return new Date(date)?.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <div className="bg-card rounded-lg overflow-hidden shadow-elevation-sm hover:shadow-elevation-md transition-smooth border border-border">
      <div className="relative h-32 md:h-40 lg:h-48 overflow-hidden">
        <Image
          src={tournament?.image}
          alt={tournament?.imageAlt}
          className="w-full h-full object-cover"
        />
        <div className={`absolute top-2 md:top-3 right-2 md:right-3 ${getStatusColor(tournament?.status)} px-2 md:px-3 py-1 rounded-full border text-xs md:text-sm font-medium capitalize`}>
          {tournament?.status}
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h4 className="text-sm md:text-base lg:text-lg font-semibold text-foreground mb-2 line-clamp-1">
          {tournament?.name}
        </h4>
        <div className="space-y-1.5 md:space-y-2 mb-3 md:mb-4">
          <div className="flex items-center gap-2 text-xs md:text-sm text-muted-foreground">
            <Icon name="Calendar" size={14} className="flex-shrink-0 md:w-4 md:h-4" />
            <span className="truncate">{formatDate(tournament?.startDate)} - {formatDate(tournament?.endDate)}</span>
          </div>
          <div className="flex items-center gap-2 text-xs md:text-sm text-muted-foreground">
            <Icon name="Users" size={14} className="flex-shrink-0 md:w-4 md:h-4" />
            <span className="data-text">{tournament?.participants} participants</span>
          </div>
          <div className="flex items-center gap-2 text-xs md:text-sm text-muted-foreground">
            <Icon name="Target" size={14} className="flex-shrink-0 md:w-4 md:h-4" />
            <span className="data-text">{tournament?.predictions} predictions</span>
          </div>
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={() => navigate(`/tournament-management/${tournament?.id}`)}
          iconName="Settings"
          iconPosition="left"
          fullWidth
          className="text-xs md:text-sm"
        >
          Manage Tournament
        </Button>
      </div>
    </div>
  );
};

export default RecentTournamentCard;